import React from 'react';
import {Form, Row, Col} from 'react-bootstrap';
import Button from '@material-ui/core/Button';
import {AutoSuggestSelect} from 'components/common';
import {fetchSchools} from 'api/schools';
import * as validators from 'utils/validators';
import {makeForm} from 'utils/common';

class UserSchoolAdditionForm extends React.Component {
  constructor(props) {
    super(props);
    this.fetchSchools = this.fetchSchools.bind(this);
  }

  fetchSchools(value) {
    return fetchSchools(value).then(({records}) => records);
  }

  render() {
    const {handleSubmit, pristine, submitting} = this.props;
    return (
      <Form onSubmit={handleSubmit}>
        <Row>
          <Col md={12}>
            <AutoSuggestSelect
              name="schools"
              label="Schools"
              labelKey="name"
              valueKey="id"
              multi
              onSearch={this.fetchSchools}
              required
              validate={[validators.isRequired]}
            />
          </Col>
        </Row>
        <Row>
          <Col xs={12}>
            <Button type="submit" variant="contained" color="primary" fullWidth disabled={pristine || submitting}>
              Add Users to Selected School(s)
            </Button>
          </Col>
        </Row>
      </Form>
    );
  }
}

export default makeForm(UserSchoolAdditionForm, 'UserSchoolAdditionForm', null, null);
